import React from "react";
import ProspectMain from "../components/propects/ProspectMain";

type Props = { utils: any; setShowExpiredAlert: any };

const Prospects = (props: Props) => {
  return (
    <div className="flex h-full min-h-0 w-full bg-background-grey">
      <ProspectMain utils={props.utils} setShowExpiredAlert={props.setShowExpiredAlert} />
    </div>
  );
};

export default Prospects;
